import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, LL_H_C, LL_V_L, performAction, TS_Loader, TS_Table } from '@nu-art/thunderstorm-frontend/index';
import './Component_RelationsTable.scss';
import RenderLeftSide from './componnents/RenderLeftSide/RenderLeftSide.js';
import RenderRightSide from './componnents/RenderRightSide/RenderRIghtSide.js';
import RenderEditColumn from './componnents/RenderEditColumn/RenderEditColumn.js';
import useForceUpdate from './hooks/useForceUpdate.js';
import { DropDown_Relations } from '../../../../shared-components/index.js';
import { ICONS } from '@app/styles';
import { QScrollWrapper, QToastContent } from '../../../../q-components/index.js';
import React from 'react';
import { ModuleFE_VariableRelation } from '../../../../../_entity/variable-relation/index.js';
const TABLE_HEADERS = [
    'Selected Variable Values',
    'Relation',
    'Variable To Compare'
];
export default function Component_RelationsTable(props) {
    const [tableData, setTableData] = React.useState();
    const [tableRows, setTableRows] = React.useState([{}]);
    const [isFetching, setFetching] = React.useState(true);
    const forceUpdate = useForceUpdate();
    React.useEffect(() => {
        const updatedDataFromCache = ModuleFE_VariableRelation.cache
            .filter(row => (row._firstVariableId === props.variable._id))
            .sort((a, b) => {
            return Number(a.__created) - Number(b.__created);
        });
        if (!tableData) {
            setTableData(updatedDataFromCache.length > 0 ? structuredClone(updatedDataFromCache)
                : [initiateDB_VariableRelations()]);
        }
        if (updatedDataFromCache.length > 0) {
            const rowRepresentation = [];
            updatedDataFromCache.map(item => rowRepresentation.push({}));
            setTableRows(rowRepresentation);
        }
        setFetching(false);
    }, []);
    const initiateDB_VariableRelations = () => {
        return {
            _firstVariableId: props.variable._id,
            leftSide: [newSideElement(true)],
            relation: '',
            rightSide: [newSideElement()]
        };
    };
    const newSideElement = (isLeftSide) => {
        return {
            variableId: isLeftSide ? props.variable._id : undefined,
            valueId: undefined
        };
    };
    const addRow = () => {
        setTableData(prevState => {
            prevState.push(initiateDB_VariableRelations());
            return prevState;
        });
        setTableRows((prev) => [...prev, {}]);
    };
    const onChangeVariableToCompare = (tableIndex, inputIndex, variable) => {
        setTableData((prev) => {
            prev[tableIndex].rightSide[inputIndex].variableId = variable._id;
            return prev;
        });
        setTableRows([...tableRows]);
    };
    const onChangeValueToCompare = (tableIndex, inputIndex, value) => {
        setTableData((prev) => {
            prev[tableIndex].rightSide[inputIndex].valueId = value._id;
            return prev;
        });
        setTableRows([...tableRows]);
    };
    const onChangeVariableValue = (tableIndex, inputIndex, value) => {
        setTableData((prev) => {
            prev[tableIndex].leftSide[inputIndex].valueId = value._id;
            return prev;
        });
        setTableRows([...tableRows]);
    };
    const onSaveRow = (newRow, index) => {
        setTableData(prevState => {
            prevState[index]._id = newRow._id;
            return prevState;
        });
        setTableRows([...tableRows]);
    };
    const onSelectRelation = (selectedRelation, index) => {
        setTableData(prevState => {
            prevState[index].relation = selectedRelation;
            return prevState;
        });
        setTableRows([...tableRows]);
    };
    const removeARow = (index) => {
        const dbTable = ModuleFE_VariableRelation.cache
            .filter(item => item._firstVariableId === props.variable._id);
        setTableRows(prevState => {
            prevState.splice(index, 1);
            return prevState;
        });
        setTableData((prevState) => {
            prevState.splice(index, 1);
            if (dbTable && dbTable[index]) {
                performAction(async () => {
                    await ModuleFE_VariableRelation.v1.deleteQuery({ where: { _id: dbTable[index]._id } }).executeSync();
                }, {
                    type: 'toast',
                    successContent: _jsx(QToastContent, { content: 'Table updated successfully', iconKey: 'v', toastType: 'success' }),
                });
            }
            return prevState;
        });
        forceUpdate();
    };
    const getTableHeaders = () => {
        return [...TABLE_HEADERS.map(i => {
                if (i === 'Variable To Compare')
                    return { header: i, widthPx: 200 };
                return { header: i, widthPx: 100 };
            }), { header: '', widthPx: 50 }];
    };
    if (isFetching)
        return _jsx(LL_H_C, { style: { width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center' }, children: _jsx(TS_Loader, {}) });
    return _jsxs(LL_V_L, { id: 'relations-tab-content', children: [_jsxs(Button, { variant: 'primary', id: 'add-relation-button', onClick: addRow, children: [_jsx(ICONS.advisor_v5_plus.component, {}), _jsx("span", { children: "Add Relation" })] }), _jsx(QScrollWrapper, { id: 'relations-table-wrapper', children: _jsx(TS_Table, { rows: tableRows, header: getTableHeaders(), headerRenderer: item => _jsx("div", { children: item }), cellRenderer: (prop, item, index) => {
                        switch (prop) {
                            case 'Selected Variable Values':
                                return _jsx(RenderLeftSide, { variable: props.variable, setTableData: setTableData, index: index, initialValue: props.value, item: tableData && tableData[index].leftSide, onChangeVariableValue: onChangeVariableValue });
                            case 'Relation':
                                return _jsx(DropDown_Relations, { index: index, relation: (tableData && tableData[index].relation.length > 0)
                                        ? tableData[index].relation : undefined, onSelectRelation: onSelectRelation });
                            case 'Variable To Compare':
                                return _jsx(RenderRightSide, { setTableData: setTableData, variable: props.variable, index: index, item: tableData && tableData[index].rightSide, onChangeVariableToCompare: onChangeVariableToCompare, onChangeValueToCompare: onChangeValueToCompare });
                            default:
                                if (['Relieving Factor', 'Precipitating Factor'].includes((tableData?.[index])?.relation ?? ''))
                                    return '';
                                return _jsx(RenderEditColumn, { row: tableData && tableData[index], variable: props.variable, onSaveRow: onSaveRow, removeARow: removeARow, index: index });
                        }
                    } }) })] });
}
//# sourceMappingURL=Component_RelationsTable.js.map